import React from "react"
import styled from "styled-components"
import {
	Container,
	Flex,
	LeftCol,
	Content,
	Header,
	RightCol,
	ProductImage,
	ProductBrand,
	ProductTitle,
	ProductPrice,
	ShopNow,
} from "./TextProduct.styles"
import { PrismicRichText } from "@prismicio/react"

export const TextProduct = ({ data }) => {
	const content = data.primary.paragraph
	const header = data.primary.heading[0]?.text
	const blurb = data.primary.blurb1[0]?.text
	const productImage = data.primary.shoppable_product?.image.src
	const productTitle = data.primary.shoppable_product?.title
	const productBrand = data.primary.shoppable_product?.vendor
	const productPrice = data.primary.shoppable_product?.variants[0].price
	const productUrl = data.primary.shoppable_product?.handle

	const fullUrl = "https://milligram.com/products/" + productUrl + ""
	return (
		<>
			<Container>
				<Flex>
					<LeftCol>
						<Header>{header}</Header>
						<Content>{blurb}</Content>
						<Content>{<PrismicRichText field={content} />}</Content>
					</LeftCol>
					<RightCol>
						<ProductImage src={productImage}></ProductImage>
						<ProductBrand>{productBrand}</ProductBrand>
						<ProductTitle>{productTitle}</ProductTitle>
						<ProductPrice>AUD {productPrice}</ProductPrice>
						<ShopNow href={fullUrl}>SHOP NOW</ShopNow>
					</RightCol>
				</Flex>
			</Container>
		</>
	)
}
